import { isEmpty } from 'lodash';
import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { createSearchParams, useNavigate } from 'react-router-dom';

import {
  CustomSlider,
  FormInput,
  HeroBanner,
  InformationsSlider,
  ProductsContextProvider,
  PromoteProducts,
  ResultsPage,
  SearchBar,
  useHomePageContext
} from 'components';
import { PAGE_TYPES } from 'constants';
import { routes } from 'router';

const GiftcardHomePage = () => {
  const { t } = useTranslation();
  const { getHomePage, homePage, newsCards, homePageLoading } = useHomePageContext();

  useEffect(() => {
    getHomePage();
  }, []);

  return (
    <div className="homepage mb-4">
      <div className="relative">
        <HeroBanner
          image={homePage?.heroImageDesktop}
          mobileImage={homePage?.heroImageMobile}
          loading={homePageLoading}
          className="hero-container gradient-small"
        />

        <SearchBar>
          <KeywordsForm />
        </SearchBar>
      </div>

      <div className="main-container pt-24 flex flex-col gap-24">
        <CustomSlider slides={newsCards || []} title={homePage?.newsSliderTitle || ''} loading={homePageLoading} />

        <PromoteProducts />

        {!isEmpty(homePage?.informationSlides) && <InformationsSlider slides={homePage?.informationSlides} />}
      </div>

      <ProductsContextProvider initialPageType={PAGE_TYPES.giftcards}>
        <>
          <div className="main-container pt-12">
            <h2 className="h2 underlined-yellow mb-12">{t('products:giftcards.allGiftcards')}</h2>
          </div>
          <ResultsPage fromHomepage />
        </>
      </ProductsContextProvider>
    </div>
  );
};

const KeywordsForm = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const form = useForm({
    mode: 'all',
    defaultValues: {
      keywords: ''
    }
  });

  const keywords = form.watch('keywords');

  const onSubmit = () => {
    const searchParams = {
      type: PAGE_TYPES.giftcards,
      keywords
    };

    navigate({
      pathname: routes.results.path,
      search: createSearchParams(searchParams).toString()
    });
  };

  return (
    <FormProvider {...form}>
      <form className="search-bar" onSubmit={form.handleSubmit(onSubmit)}>
        <div className="grow">
          <FormInput
            name="keywords"
            placeholder={t('form:placeholders.searchGiftcard')}
            label={t('form:search')}
            className="search-input"
            rules={{ required: true }}
          />
        </div>

        <button
          type="submit"
          className="btn secondary uppercase mt-2 mx-4 lg:mt-0 lg:mr-2 xl:mr-4"
          disabled={isEmpty(keywords)}
        >
          {t('buttons.search')}
        </button>
      </form>
    </FormProvider>
  );
};

export default GiftcardHomePage;
